import {
  FETCH_ROUTE,
  SEARCH_ROUTES,
  GET_LOCATION_SUGGESTIONS,
  SELECT_ROUTE,
  CHECK_FOR_MAPS_SCRIPT,
  DELETE_ROUTE,
  DELETE_ROUTE_BOOKMARK,
  LOAD_USER_SEARCH_PAGE,
  SEARCH_MY_ROUTES,
  GET_BOOKMARKED_ROUTES,
  LOAD_USER_ROUTES,
} from './constants'

import * as routeHelpers from './helpers'

export function getRoutesByUser (userId, limit, orderBy = 'date_created') {
  const params = {
    limit: limit,
    user: userId,
    order_by: orderBy,
  }

  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: LOAD_USER_ROUTES,
      payload: mapmy.listRoutes(params),
    })
  }
}

export function fetchDetailedInternalRoute (routeId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_ROUTE,
      payload: mapmy.getDetailedInternalRoute(routeId),
    })
  }
}

export function verifyGoogleMapsScriptLoad () {
  return (dispatch, getState, { googleMaps }) => {
    return dispatch({
      type: CHECK_FOR_MAPS_SCRIPT,
      payload: googleMaps.verifyGoogleMapsScriptLoad(),
    })
  }
}

export function searchRoutes (formData = null, showOldest = false, customLocation = null) {
  return (dispatch, getState, { mapmy }) => {
    const orderBy = showOldest ? 'date_created' : '-date_created'
    let dataForSearch

    if (!formData) {
      dataForSearch = getState().form.routeSearch.values

      if (customLocation) {
        dataForSearch.location = customLocation
      }
    } else {
      dataForSearch = formData
    }

    const searchParams = routeHelpers.translateSearchData(dataForSearch, orderBy)

    return dispatch({
      type: SEARCH_ROUTES,
      payload: mapmy.listRoutes(searchParams),
      meta: {
        unitPreference: dataForSearch.unit,
        searchCoords: dataForSearch.location,
        globalErrorNotification: true,
      },
    })
  }
}

export function getNextRoutes () {
  return (dispatch, getState, { mapmy }) => {
    const link = getState().routes.nextRoutesLink
    return dispatch({
      type: SEARCH_ROUTES,
      payload: mapmy.getPaginatedRoutes(link),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getPrevRoutes () {
  return (dispatch, getState, { mapmy }) => {
    const link = getState().routes.prevRoutesLink
    return dispatch({
      type: SEARCH_ROUTES,
      payload: mapmy.getPaginatedRoutes(link),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getLocationSuggestions (location, setUserCoords = false) {
  return (dispatch, getState, { googleMaps }) => {
    return dispatch({
      type: GET_LOCATION_SUGGESTIONS,
      payload: googleMaps.geocode(location),
      meta: {
        setUserCoords: setUserCoords,
      },
    })
  }
}

export function selectRoute (routeId) {
  return (dispatch) => {
    return dispatch({
      type: SELECT_ROUTE,
      selectedRouteId: routeId,
    })
  }
}

export function searchMyRoutesByName ({ text, userId }) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: SEARCH_MY_ROUTES,
      payload: mapmy.listRoutes({
        limit: 40,
        offset: 0,
        text_search: text,
        user: userId,
        order_by: '-text_match',
      }),
    })
  }
}

export function loadMyRoutesPage ({ offset, limit, userId, searchTerm, orderBy, cache }) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: LOAD_USER_SEARCH_PAGE,
      payload: mapmy.listRoutes({
        limit: limit,
        offset: offset,
        user: userId,
        text_search: searchTerm,
        order_by: orderBy,
      }, cache).then(({ data }) => {
        return {
          count: data.total_count,        // must return count as a number
          results: data._embedded.routes, // must return results as an array
        }
      }),
    })
  }
}

export function getBookmarkedRoutes ({ offset, limit, userId }) {
  let routeBookmarks = []

  return (dispatch, getState, { mapmy }) => {
    const promise = Promise.resolve()
      .then(() => {
        return mapmy.getBookmarkedRoutes({
          limit: limit,
          offset: offset,
          user: userId,
        })
      }).then((bookmarks) => {
        routeBookmarks = bookmarks.data._embedded.route_bookmarks
        const routeIds = routeBookmarks.map((route) => route._links.route[0].id)
        const searchString = routeIds.toString()

        if (routeIds.length) {
          return mapmy.getBatchOfRoutes(searchString)
        }

        // If the user has no bookmarks, return a 'fake' empty response
        return Promise.resolve({
          data: {
            _embedded: {
              routes: [],
            },
            total_count: 0,
          },
        })
      }).then((routes) => {
        const enhancedRoutes = routes.data._embedded.routes.map((route) => {
          const bookmark = routeBookmarks.filter((routeBookmark) => {
            return route._links.self[0].id === routeBookmark._links.route[0].id
          })[0]

          route._links.bookmark = bookmark._links.self

          return route
        })

        return {
          count: routes.data.total_count,
          results: enhancedRoutes,
        }
      })

    return dispatch({
      type: GET_BOOKMARKED_ROUTES,
      payload: promise,
    })
  }
}

export function deleteRoute (routeId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: DELETE_ROUTE,
      payload: mapmy.deleteRoute(routeId),
      meta: {
        deletedRouteId: routeId,
      },
    })
  }
}

export function deleteRouteBookmark (bookmarkId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: DELETE_ROUTE_BOOKMARK,
      payload: mapmy.deleteRouteBookmark(bookmarkId),
      meta: {
        deletedBookmarkId: bookmarkId,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/routes/actions.js